<template>
<div>
  <div class="event-list-wrapper" v-if="parentActiveIndex == 1">
    <div class="stats-container">
      <div class="stat-item">
        <span class="label">待处理事件</span>
        <span class="value" style="color: #019183;">{{ processingNum }}</span>
      </div>
      <div class="stat-item">
        <span class="label">超时未处理</span>
        <span class="value" style="color: #f5222d;">{{ timeoutNum }}</span>
      </div>
      <div class="stat-item">
        <span class="label">本周新增</span>
        <span class="value" style="color: #1890ff;">{{ newNum }}</span>
      </div>
      <div class="stat-item">
        <span class="label">处理完成率</span>
        <span class="value" style="color: #019183;">{{ completionRate }}%</span>
      </div>
    </div>
    <div class="event-list-container" ref="eventListContainer">
      <!-- 标题 -->
      <h3 class="event-list-title">事件列表</h3>


      <!-- 事件列表 -->
      <div class="event-items">
        <!-- 处理中事件 -->
        <!-- 使用ref替代ID，更安全的获取方式 -->
      <div class="scroll-wrapper" ref="scrollWrapper">
          <ul  
              infinite-scroll-disabled="loading"
              infinite-scroll-distance="10"
              infinite-scroll-container="this.$refs.scrollWrapper"
              style="padding: 0px;margin: 0px;"
              class="infinite-list"
              ref="infiniteList"
          >
              <li v-for="(item, index) in events" class="infinite-list-item" style="color: #fff;" :key="index">
                <el-card class="event-card">
                  <div slot="header" class="event-status" style="display: flex;justify-content: space-between;">
                    <div>
                      <i class="el-icon-loading" style="color: rgba(117, 224, 160, 1);" v-if="item.complaintSuggestion.isHandle==0"></i>
                      <i class="el-icon-error" style="color: rgba(255, 58, 58, 1;" v-if="item.complaintSuggestion.isHandle == 1"></i>
                      <!-- <i class="el-icon-success" style="color: rgba(255, 58, 58, 1);" v-if="item.complaintSuggestion"></i> -->
                      <span v-if="item.complaintSuggestion.isHandle == 0" style="color: rgba(117, 224, 160, 1);">处理中</span>
                      <span v-if="item.complaintSuggestion.isHandle == 1" style="color: rgba(255, 58, 58, 1);">已超时</span>
                    </div>
                    <div>
                      <el-button type="text" class="action-btn" @click="openProgressDialog(item)">记录详情</el-button>
                      <el-button type="text" class="action-btn" @click="openInterveneDialog(item)" v-if="item.complaintSuggestion.isHandle == 1">介入处理</el-button>
                      <el-button type="text" class="action-btn" @click="onUnder" v-if="item.complaintSuggestion.isHandle == 1">发起督办</el-button>
                    </div>
                  </div>
                  <div class="event-content">
                    <h4 class="community-name">{{ item.complaintSuggestion.communityName }}-{{item.complaintSuggestion.estateName}}</h4>
                    <p class="event-desc">{{ item.complaintSuggestion.problemDescription }}</p>
                    <p class="event-desc" v-if="item.complaintSuggestion.propertyResponse">{{ item.complaintSuggestion.propertyResponse }}</p>
                    <div class="event-meta">
                      <span class="event-time">事件时间：{{ item.complaintSuggestion.createTime }}</span>
                      <span class="handle-limit" v-if="item.interfere">要求完成时间：24小时</span>
                      <span class="handler">小区负责人：{{ item.complaintSuggestion.dirctorName?item.complaintSuggestion.dirctorName:'暂无' }}</span>
                      <span class="handler">联系电话：{{ item.complaintSuggestion.dirctorPhone?item.complaintSuggestion.dirctorPhone:'暂无' }}</span>
                    </div>
                  </div>
                </el-card>
              </li>
            </ul>
        </div>
        <!-- 即将超时事件 -->
<!--        <el-card class="event-card">-->
<!--          <div slot="header" class="event-status">-->
<!--            <i class="el-icon-clock"></i>-->
<!--            <span>即将超时</span>-->
<!--            <div class="action-btn">-->
<!--              <el-button type="text" class="action-btn" @click="onUnder">介入处理</el-button>-->
<!--              <el-button type="text" class="action-btn" @click="onUnder">发起督办</el-button>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="event-content">-->
<!--            <h4 class="community-name">昱光苑小区</h4>-->
<!--            <p class="event-desc">昱光苑小区3栋发生高空抛物告警，请及时安排相关负责人员前往事发地查看，记录并核查相关人员。</p>-->
<!--            <div class="event-meta">-->
<!--              <span class="event-time">事件时间：2025-01-01 12:19</span>-->
<!--              <span class="handle-limit">处理时限：24小时</span>-->
<!--              <span class="handler">处理人：王物业</span>-->
<!--            </div>-->
<!--          </div>-->
<!--        </el-card>-->

        <!-- 已超时事件 -->
<!--        <el-card class="event-card">-->
<!--          <div slot="header" class="event-status">-->
<!--            <i class="el-icon-error"></i>-->
<!--            <span>已超时</span>-->
<!--            <div class="action-btn">-->
<!--              <el-button type="text" class="action-btn" @click="onUnder" >介入处理</el-button>-->
<!--              <el-button type="text" class="action-btn" @click="onUnder">发起督办</el-button>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="event-content">-->
<!--            <h4 class="community-name">昱光苑小区名称</h4>-->
<!--            <p class="event-desc">昱光苑小区3栋发生高空抛物告警，请及时安排相关负责人员前往事发地查看，记录并核查相关人员。</p>-->
<!--            <div class="event-meta">-->
<!--              <span class="event-time">事件时间：2025-01-01 12:19</span>-->
<!--              <span class="handle-limit">处理时限：24小时</span>-->
<!--              <span class="handler">处理人：王物业</span>-->
<!--            </div>-->
<!--          </div>-->
<!--        </el-card>-->
      </div>
    </div>

    
  </div>
  <!-- 进度查看弹窗 -->
    <vue-progress-dialog
        v-if="progressDialogVisible"
        :visible.sync="progressDialogVisible"
        :event-info="currentEventInfo || {}"
        :processing-steps="currentProcessingSteps"
        :intervention="currentIntervention || null"
        @close="closeProgressDialog">
    </vue-progress-dialog>
    <vue-intervene
        :visible.sync="interveneDialogVisible"
        :event-info="currentEventInfo"
        @close="closeInterveneDialog">
    </vue-intervene>
  <div class="event-list-container1" v-if="parentActiveIndex==2">
        <h3 class="event-list-title">事件列表</h3>
        <div class="scroll-wrapper1" ref="scrollWrapper">
          <ul  
              infinite-scroll-disabled="loading"
              infinite-scroll-distance="10"
              infinite-scroll-container="this.$refs.scrollWrapper"
              style="padding: 0px;margin: 0px;"
              class="infinite-list"
              ref="infiniteList"
          >
              <li v-for="(item, index) in events" class="infinite-list-item" style="color: #fff;" :key="index">
                <el-card class="event-card">
                  <div slot="header" class="event-status" style="display: flex;justify-content: space-between;">
                    <div>
                      <i class="el-icon-loading" style="color: rgba(117, 224, 160, 1);" v-if="item.complaintSuggestion.isHandle==0"></i>
                      <i class="el-icon-error" style="color: rgba(255, 58, 58, 1;" v-if="item.complaintSuggestion.isHandle == 1"></i>
                      <!-- <i class="el-icon-success" style="color: rgba(255, 58, 58, 1);" v-if="item.complaintSuggestion"></i> -->
                      <span v-if="item.complaintSuggestion.isHandle == 0" style="color: rgba(117, 224, 160, 1);">处理中</span>
                      <span v-if="item.complaintSuggestion.isHandle == 1" style="color: rgba(255, 58, 58, 1);">已超时</span>
                    </div>
                    <div>
                      <el-button type="text" class="action-btn" @click="openProgressDialog(item)">记录详情</el-button>
                      <el-button type="text" class="action-btn" @click="onUnder">发起督办</el-button>
                    </div>
                  </div>
                  <div class="event-content">
                    <h4 class="community-name">{{ item.complaintSuggestion.communityName }}-{{item.complaintSuggestion.estateName}}</h4>
                    <p class="event-desc">{{ item.complaintSuggestion.problemDescription }}</p>
                    <p class="event-desc" v-if="item.complaintSuggestion.propertyResponse">{{ item.complaintSuggestion.propertyResponse }}</p>
                    <div class="event-meta">
                      <span class="event-time">事件时间：{{ item.complaintSuggestion.createTime }}</span>
                      <span class="handle-limit" v-if="item.interfere">要求完成时间：24小时</span>
                      <span class="handler">小区负责人：{{ item.complaintSuggestion.dirctorName?item.complaintSuggestion.dirctorName:'暂无' }}</span>
                      <span class="handler">联系电话：{{ item.complaintSuggestion.dirctorPhone?item.complaintSuggestion.dirctorPhone:'暂无' }}</span>
                    </div>
                  </div>
                </el-card>
              </li>
            </ul>
        </div>
  </div>
</div>
</template>

<script>
import VueProgressDialog from './vueprogressdialog.vue';
import VueIntervene from './vueintervene.vue';
import {Message} from "element-ui";
import {getEstateAllComplaint,getWeekAdd,interfereList} from "@/api/estate";

export default {
  name: 'EventList',
  components: {
    VueProgressDialog,
    VueIntervene
  },
  data() {
    return {
      // 可以在这里添加事件数据
      processingNum: 0,
      timeoutNum: 0,
      newNum: 0,
      completionRate: 0,
      estateId: '',
      events: [],
      parentActiveIndex: 1,
      activeType: '投诉', // 默认选中"投诉"
      progressDialogVisible: false,
      interveneDialogVisible: false,
      currentEventInfo: null,
      currentProcessingSteps: [],
      currentIntervention: null
    }
  },
  mounted() {
      
      // 确保DOM完全渲染后再执行
      this.$nextTick(() => {
          // 安全检查：先确认元素存在
          if (this.$refs.scrollWrapper && this.$refs.infiniteList) {
              // 绑定滚动事件
              this.$refs.scrollWrapper.addEventListener('scroll', this.handleManualScroll);
              // 检查初始内容
              this.ensureEnoughContent();
          } else if (!this._isDestroyed) {
              // 重试机制：100ms后再次尝试
              setTimeout(() => {
                if (!this._isDestroyed) this.mounted();
              }, 100);
          }
      });
  },
  beforeDestroy() {
      // 移除事件前先检查元素是否存在
      if (this.$refs.scrollWrapper) {
          this.$refs.scrollWrapper.removeEventListener('scroll', this.handleManualScroll);
      }
  },
  mounted() {
    this.$on('sync-option',(index,parentActiveIndex,id,type)=>{
      // console.log(index,parentActiveIndex,id,type);
      this.estateId = id;
      this.parentActiveIndex = parentActiveIndex;
      if (parentActiveIndex==1){
        this.loadEvents(id);
        this.getWeekAdd(id);
      }else if(parentActiveIndex==2){
        if(type == 1) {
          this.interfereList();
        }
      }
    })
  },
  methods: {
    getWeekAdd(id){
      getWeekAdd({
        estateId: id
      }).then(res => {
        this.processingNum = res.data.processingNum
        this.timeoutNum = res.data.timeoutNum
        this.newNum = res.data.newNum
        this.completionRate = res.data.completionRate
      })
    },
    ensureEnoughContent() {
        // 双重安全检查
        if (!this.$refs.scrollWrapper || !this.$refs.infiniteList) return;
        
        const container = this.$refs.scrollWrapper;
        const list = this.$refs.infiniteList;
        
        // 确保容器和列表的高度都有效
        if (container.clientHeight && list.clientHeight && list.clientHeight <= container.clientHeight) {
            // this.load();
        }
    },
    handleManualScroll() {
        if (!this.$refs.scrollWrapper) return;
        
        const container = this.$refs.scrollWrapper;
        const scrollBottom = container.scrollHeight - container.scrollTop - container.clientHeight;
        // console.log('scrollBottom', scrollBottom == 0);
        if (scrollBottom == 0) {
            this.load();
        }
    },
    onUnder() {
      Message.info('功能开发中，敬请期待！');
    },
    handleTypeClick(type) {
      this.activeType = type;
    },
    // 打开进度弹窗
    openProgressDialog(item) {
      this.currentEventInfo = item.complaintSuggestion || {};
      this.currentIntervention = item.interfere || null;
      this.progressDialogVisible = true;
    },
    // 关闭进度弹窗
    closeProgressDialog() {
      this.progressDialogVisible = false;
    },
    openInterveneDialog(item) {
      this.currentEventInfo = item.complaintSuggestion || {};
      this.interveneDialogVisible = true;
    },
    closeInterveneDialog() {
      this.interveneDialogVisible = false;
      this.loadEvents(this.estateId);
      this.getWeekAdd(this.estateId);
    },
    // 加载事件数据的方法
    interfereList() {
      interfereList().then(res=>{
        this.events = res.rows;
      })
    },
    // 加载事件数据的方法
    loadEvents(estateId) {
      let data={};
      data.estateId=estateId
      getEstateAllComplaint(data).then(res=>{
        this.events = res.rows;
      })
    }
  }
}
</script>

<style scoped>
.scroll-container {
    padding: 20px;
    width: 1200px;
    height: 700px;
    background: rgba(0,0,0,0.7);
}

.scroll-wrapper {
    width: 1200px;
    height: 580px;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    box-sizing: border-box;
}

.scroll-wrapper1 {
    width: 1200px;
    height: 710px;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    box-sizing: border-box;
}

.infinite-list-item {
    margin-top: 15px;
    margin-right: 10px;
}

.event-list-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.stats-container {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  padding: 10px 0;
  width: 1250px;
  box-sizing: border-box;
}

.stat-item {
  background-color: rgba(4, 13, 16, 0.8);
  border: 1px solid #019183;
  border-radius: 4px;
  padding: 10px 15px;
  color: #fff;
  font-size: 16px;
  text-align: center;
  flex: 1;
  margin: 0 5px;
  box-sizing: border-box;
  position: relative;
}

.stat-item::before,
.stat-item::after {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  width: 1px;
  background-color: #019183;
}

.stat-item::before {
  left: 0;
}

.stat-item::after {
  right: 0;
}

.stat-item .label {
  display: block;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 5px;
}

.stat-item .value {
  font-size: 20px;
  font-weight: bold;
}

.event-list-container {
  background-color: rgb(4, 13, 16, 0.8);
  color: #fff;
  padding: 20px;
  width: 1250px;
  height: 100%;
  box-sizing: border-box;
  overflow-y: auto;
  position: relative;
}

.event-list-container1 {
  background-color: rgb(4, 13, 16, 0.8);
  color: #fff;
  padding: 20px;
  width: 1250px;
  height: 800px;
  box-sizing: border-box;
  overflow-y: auto;
  position: relative;
}

.event-list-title {
  margin: 0 0 20px 0;
  font-size: 18px;
  font-weight: normal;
}

.event-type-buttons {
  margin-bottom: 25px;
}

.type-btn {
  background-color: #0f3d39;
  border-color: #019183;
  margin-right: 10px;
  font-size: 18px;
  padding: 8px 16px;
  border-radius: 4px;
}

.type-btn[plain] {
  background-color: transparent;
  color: #019183;
  border-color: #019183;
}

.type-btn[plain]:hover {
  background-color: rgba(1, 145, 131, 0.1);
}

.type-btn.is-active {
  background-color: #019183;
  color: white;
  border-color: #019183;
}

.event-items {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.event-card {
  background-color: transparent;
  border: 1px solid #2a4361;
  border-radius: 4px;
  overflow: hidden;
}

.event-card::v-deep .el-card__header {
  border-bottom: none !important;
  padding: 0 0 0 0;
  background: linear-gradient(to right, rgba(15, 61, 58, 0.5) 0%, rgba(15, 61, 58, 0) 100%);
}

.event-card::v-deep .el-card__body {
  padding: 0;
}

.event-status {
  display: flex;
  align-items: center;
  padding: 8px 15px;
  font-size: 18px;
  color: rgba(255, 255, 255, 0.5);
}

.event-status i {
  margin-right: 5px;
}

.warning .event-status {
  background-color: #faad14;
  color: #fff;
}

.danger .event-status {
  background-color: #f5222d;
  color: #fff;
}

.event-content {
  padding: 15px;
}

.community-name {
  margin: 0 0 10px 0;
  font-size: 16px;
  font-weight: 500;
  color: #fff;
}

.event-desc {
  margin: 0 0 15px 0;
  color: #b4c2d1;
  line-height: 1.5;
}

.event-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  font-size: 12px;
  color: #86909c;
}

.event-actions {
  display: flex;
  justify-content: flex-end;
  padding: 10px 15px;
  background-color: rgba(255, 255, 255, 0.03);
  border-top: 1px solid #2a4361;
}

.action-btn {
  color: #0EE0D4;
  background:rgba(22, 93, 86, 0.6);
  padding: 8px 10px;
  border-radius: 4px;
  border: 1px solid rgba(14, 224, 212, 0.6);
  font-size: 13px;
}

.action-btn:hover {
  color: #40a9ff;
}
</style>
